export enum OrigemUserSituation {
  Ativo = 'Ativo',
  Inativo = 'Inativo'
}
